import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals'; // Adjust the path if needed
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AspCustomerDetailsService {

  constructor(private http: HttpClient) { }
  getCustomerDetails(garageKey,customerId,mobileNumber){
    let param={
   garageKey: garageKey,
    customerId: customerId,
    mobileNumber: mobileNumber
    }
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garageCustomer/v1/customer/detail`,param)
  }
}
